export const monitoringMenuData = [
  {
    title: 'AML 모니터링',
    id: 'AML',
    menuIcon: '📊',
    routerPath: 'MONITORING_AML',
  }
]